import React from 'react'
import logo from './logo.png'
import { TypeAnimation } from 'react-type-animation'
import Legitimacy from './legitimacy'
import Features from './features'
import Profits from './profits'
import Earnings from './earnings'
import Ending from './ending'
import referral from './referral.png'
import education from './education.png'
import staking from './staking.png'
import timeline from './timeline.png'
import about from './about.png'

const About = () => {
    return (
        <div>
            <div className='container-fluid' style={{ backgroundColor: "#23153c" }}>
                {/* <div className="d-flex justify-content-center"> */}

                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="py-md-5">
                            <div className="py-5">
                                <div>
                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>Get to Know                                   </h1>

                                    {/* <h1 className='' >
                                        <TypeAnimation
                                            sequence={[
                                                // Same substring at the start will only be typed once, initially
                                                'WEALTH',
                                                1000,
                                                'LIFE',
                                                1000,
                                                'DREAMS',
                                                1000,
                                                'FORTUNES',
                                                1000,
                                                'PLANS',
                                                1000,

                                                'GOALS',
                                                1000,
                                            ]}
                                            speed={50}

                                            className="text-light display-4"
                                            style={{ fontWeight: 'bold' }}
                                            repeat={Infinity}
                                        /></h1> */}
                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>Vertex Chain</h1>
                                    <p className="text-light display-6">Discover our mission, values, and team that make VCT a trusted decentralized investment platform. Join us on a journey to explore how blockchain technology and smart contracts drive our success.
                                    </p>
                                    <p className="text-light display-6">We ensure full transparency, security, and profitability in every transaction.</p>
                                    {/* <p className="text-light h4">VCT's Decentralized Smart Contract Platform</p> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={about} class="brand-image p-md-none" alt="..." />
                    </div>
                </div>

                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="">
                            <div className="py-5">
                                <h1 style={{ fontWeight: 500 }} className="display-4 text-light my-3">VCT Journey Timeline
                                </h1>
                                <p className="text-light display-6">VCT started with a vision to revolutionize decentralized finance by integrating staking rewards, blockchain investments, and global business expansion. Our transparent smart contract ensures fairness, while our roadmap includes NFTs, Global Expansion, and a Gaming Platform, shaping the future of financial independence.</p>



                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={timeline} class=" p-md-none p-5 img-fluid" alt="..." />
                    </div>
                </div>



            </div>

            <div className="container-fluid px-md-5 py-md-5">
                <Ending />

            </div>
        </div>
    )
}

export default About